import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useStepValidationStrategy } from '@/features/proposta/hooks'
import {
  StepPropostaContent,
  StepPropostaHeaderContent,
  StepPropostaHeaderTitle,
  StepPropostaRoot,
  StepPropostaFooter,
  StepPropostaHeaderDescription,
} from '@/features/proposta/layouts'
import type { TPropostaSchemaInput } from '@/features/proposta/schemas'
import { CardPlanta } from '@/pages/proposta/etapa-informacoes-iniciais/planta/card-planta-bloco'
import { CardVagaPadrao } from '@/pages/proposta/etapa-informacoes-iniciais/vaga-padrao/card-vaga-padrao'
import { CardVendedorResponsavel } from '@/pages/proposta/etapa-informacoes-iniciais/vendedor/card-vendedor-responsavel'
import { Render } from '@/shared/components/render-if'
import { Button } from '@/shared/components/ui'

export const InformacoesIniciaisStep = () => {
  const { t } = useTranslation('proposta')
  const { watch, trigger, setValue } = useFormContext<TPropostaSchemaInput>()
  const simulacaoUnidade = watch('informacoesIniciais.simulacaoUnidade')

  const { validateStep } = useStepValidationStrategy(trigger)

  const handleNextStep = async () => {
    const isValid = await validateStep('InformacoesIniciaisStep')
    if (!isValid) return
    setValue('step', 1)
  }

  return (
    <StepPropostaRoot>
      <StepPropostaHeaderContent>
        <StepPropostaHeaderTitle className="hidden md:block">
          {t('informacoes_iniciais.titulo')}
        </StepPropostaHeaderTitle>
        <StepPropostaHeaderDescription className="hidden md:block">
          {t('informacoes_iniciais.subtitulo')}
        </StepPropostaHeaderDescription>
      </StepPropostaHeaderContent>
      <StepPropostaContent>
        <div className="flex w-full flex-wrap gap-4">
          <Render.If condition={simulacaoUnidade}>
            {() => (
              <>
                <CardVagaPadrao />
                <CardPlanta />
              </>
            )}
          </Render.If>
          <CardVendedorResponsavel />
        </div>
      </StepPropostaContent>
      <StepPropostaFooter className="justify-end">
        <Button className="font-nunito h-12 w-full md:w-auto" variant="default" onClick={handleNextStep}>
          {t('proxima_etapa')}
        </Button>
      </StepPropostaFooter>
    </StepPropostaRoot>
  )
}
